import TimerIcon from '@mui/icons-material/Timer';
import { TextField } from '@mui/material';
import { Handle, Position } from '@xyflow/react';
import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledHandle = styled(Handle)(({ theme }) => ({
  width: 10,
  height: 10,
  backgroundColor: "black",
  border: "white",
}));

const NodePaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  minWidth: 200,
  backgroundColor: '#ffffff',
  border: `2px solid ${theme.palette.black['100']}`,
  borderRadius: theme.spacing(1),
  boxShadow: theme.shadows[3],
  '&:hover': {
    boxShadow: theme.shadows[6],
  }
}));

export function WaitNode({ data, id }) {
  const handleDaysChange = (event) => {
    const newDays = parseInt(event.target.value) || 3;
    data.onChange?.(newDays); // Call the onChange handler passed in data
  };

  return (
    <NodePaper elevation={3}>
      <StyledHandle
        type="target"
        position={Position.Top}
        isConnectable={true}
      />

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        py: 1
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TimerIcon color="warning" />
          <Typography variant="subtitle1" color="warning.main">
            Wait
          </Typography>
        </Box>
        <TextField
          size="small"
          type="number"
          label="Days"
          value={data?.days || 3}  // Use value instead of defaultValue
          onChange={handleDaysChange}
          InputProps={{ inputProps: { min: 1 } }}
          sx={{ width: 100 }}
        />
      </Box>
      <StyledHandle
        type="source"
        position={Position.Bottom}
        id="b"
        isConnectable={true}
      />
    </NodePaper>
  );
}